import * as React from "react";

interface DateInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange" | "value" | "type"> {
  /** Current value in yyyy-mm-dd format. */
  value: string;
  /** Called with the new value string. */
  onChange: (value: string) => void;
  /** Optional range bounds (yyyy-mm-dd). */
  min?: string;
  max?: string;
}

/**
 * A native date input that opens the calendar picker on click (not just on the
 * tiny icon), with graceful fallback where showPicker() isn't supported.
 * Any extra input props (disabled, name, id, style, aria-*, etc.) pass through.
 */
export default function DateInput({
  value,
  onChange,
  min,
  max,
  className = "form-control",
  ...rest
}: DateInputProps) {
  const openPicker = (e: React.MouseEvent<HTMLInputElement>) => {
    const el = e.currentTarget as HTMLInputElement & { showPicker?: () => void };
    if (typeof el.showPicker === "function") {
      e.preventDefault();
      el.showPicker();
    }
  };

  return (
    <input
      {...rest}
      type="date"
      className={className}
      value={value}
      min={min}
      max={max}
      onMouseDown={openPicker}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}